export const DOCUMENT_ACTIONS_OWNER = 'Nutrient Document Actions';
export const DOCUMENT_ACTIONS = {
    VIEW_AND_SIGN: 'View and Sign Document'
};